<template>
  <div
    class="widgets-outer-casing"
    @click="$emit('click')"
    :class="{ 'scroll-touch' : !isScroll }"
    :style="widgetStyle"
  >
    <BetterScroll v-if="isScroll">
      <slot />
    </BetterScroll>
    <slot v-else />
  </div>
</template>

<script>
import BetterScroll from '$common/components/better-scroll';
export default {
  components: { BetterScroll },
  props: {
    isScroll: {
      type: Boolean,
      default: () => false
    },
    disabledScreenComputed: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    widgetStyle() {
      return `height: ${this.$root.clientHeight}px;`;
    }
  },
  mounted() {
    this.$nextTick(() => this.$emit('load'));
  }
}
</script>
<style scoped lang="stylus">
  .widgets-outer-casing {
    width: 100%;
    min-height: 100vh;
    position: relative;
  }
</style>
